"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.editDynamicColumnFormConfig = void 0;
exports.editDynamicColumnFormConfig = {
    type: 'form',
    children: [
        {
            type: 'form.text',
            key: 'metadata.label',
            label: 'Label',
            validate: {
                required: true,
            },
        },
        {
            type: 'form.checkbox',
            key: 'metadata.showInTable',
            label: 'Show In Table',
            style: {
                type: 'checkbox',
            },
            defaultValue: false,
        },
        {
            type: 'form.checkbox',
            key: 'metadata.showInFilters',
            label: 'Show In Filter',
            style: {
                type: 'checkbox',
            },
            defaultValue: false,
        },
    ],
};
